import React, { Fragment, useState } from 'react'
import Select from 'react-select'
import { ModalHeader, ModalBody, FormGroup, Col, Label, ModalFooter, Button } from 'reactstrap'
import { Alert } from 'antd'

export default function PaymentTransferModal(props) {
  const [selectedOrderOption, setSelectedOrderOption] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  const transferPayment = () => {
    setIsLoading(true)
    props.transferPayment.create({
      payment_id: props.paymentId,
      source_order_id: props.sourceOrderId,
      destination_order_id: selectedOrderOption.key,
    }).then(props.refreshOrder).finally(() => setIsLoading(false))
  }

  return (
    <Fragment>
      <ModalHeader toggle={props.onHide}>Transfer Payment</ModalHeader>
      <ModalBody>
        <FormGroup row>
          <Col xs="12">
            <Alert
              className="mb-3"
              message="Transfer of funds is final. Please confirm before proceeding."
              type="warning"
            />
            <Label>Destination Order</Label>
            <Select
              value={selectedOrderOption}
              valueKey='key'
              labelKey='value'
              onChange={setSelectedOrderOption}
              options={props.orderOptions}
            />
          </Col>
        </FormGroup>
      </ModalBody>
      <ModalFooter className="border-0">
        <Button onClick={props.onHide} color="secondary">Cancel</Button>
        <Button disabled={!selectedOrderOption || isLoading} onClick={transferPayment}>
          Transfer
        </Button>
      </ModalFooter>
    </Fragment>
  )
}
